import CrudBaseService from "@/services/CrudBaseService";

export default class StudyConfigurationService extends CrudBaseService {
  constructor() {
    super('odoo/study_configuration');
  }

  findAllBySalesChannelId(salesChannelId) {
    return this.http.get(`${this._serviceName}/sales-channel/${salesChannelId}`);
  }
  
  findByCity(params) {
    return this.http.get(`${this._serviceName}/find-by-city?${params}`);
  }
}
